<template>
  <div><Head title="User Manual" /><PageHeader title="User Manual" icon="issues" description="Read the ESTAT guide for your account." />
    <section class="manual-panel"><h2>{{ manual.label }} User Manual</h2>
      <template v-if="manual.available"><p>Updated: {{ manual.updated_at }}</p><a href="/user-manual/pdf" target="_blank" rel="noopener noreferrer">View User Manual ↗</a></template>
      <p v-else>No user manual has been published yet. Please contact the ESTAT administrator.</p>
    </section>
  </div>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import PageHeader from '@/Shared/PageHeader'
export default { components: { Head, PageHeader }, layout: Layout, props: { manual: Object } }
</script>
<style scoped>
.manual-panel { background: white; padding: 28px; border-radius: 14px; color: #344767; }h2 { color: #006483; font-size: 20px; font-weight: 700; margin-bottom: 18px; }p { margin-bottom: 18px; overflow-wrap: anywhere; }a { display: inline-block; background: #006483; color: white; padding: 12px 20px; border-radius: 8px; }
</style>